import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Box } from "@mui/material";

import "../../assets/transactions.scss";
import { history, pendingConfirmations } from "../messages";
import TransactionCommon from "../TransactionCommon";
import PendingTransactionsCommon from "../PendingTransactionsCommon";
import CommonHeader from "../CommonHeader";
import WalletSymbols from "../WalletSymbols";
import { downloadStatementIcon } from "../images";

const AllTransaction = (props) => {
  const location = useLocation();
  const [transactions, setTransactions] = useState([]);
  const [open, setOpen] = useState(false);
  const [openStatementDrawer, setOpenStatementDrawer] = useState(false);
  const [openRequestSentDrawer, setOpenRequestSentDrawer] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const filterComponent = transactions && (
    <Box display="flex" flexDirection="row" gap={2}>
      <img
        src={downloadStatementIcon}
        height={24}
        width={24}
        alt="download statement icon"
        className="cursor-pointer"
        onClick={() => {
          setOpenStatementDrawer(true);
        }}
      />
      <WalletSymbols
        symbol="tune"
        action={() => setOpen(true)}
        customClass="cursor-pointer"
        sx={{ color: "#041F61" }}
      />
    </Box>
  );

  const historyProps = {
    textAfterIcon: history,
    rightSideComponent: filterComponent,
  };
  const pendingTransactionProps = {
    textAfterIcon: pendingConfirmations,
    icon: "backArrow",
  };
  return (
    <>
      <CommonHeader
        {...(location.pathname === "/history"
          ? historyProps
          : pendingTransactionProps)}
      />

      <Box className="options-container">
        <Box className="all-transaction-wrapper">
          {location.pathname === "/history" ? (
            <TransactionCommon
              isFromBrowser={true}
              transactions={transactions}
              setTransactions={setTransactions}
              open={open}
              setOpen={setOpen}
              openStatementDrawer={openStatementDrawer}
              setOpenStatementDrawer={setOpenStatementDrawer}
              openRequestSentDrawer={openRequestSentDrawer}
              setOpenRequestSentDrawer={setOpenRequestSentDrawer}
            />
          ) : (
            <PendingTransactionsCommon isFromBrowser={true} />
          )}
        </Box>
      </Box>
    </>
  );
};

export default AllTransaction;
